export default function ($) {

    var $links = $('.site-footer .dropdown:not(.label) .dropdown-toggle');

    if ($links.length <= 0) {
        return;
    }

    var allowedDomains = [
        window.location.hostname,
        'updater.com',
        'updaterstg.wpenginepowered.com',
        'updaterdev.wpenginepowered.com',
    ];

    $links.removeAttr('data-bs-toggle');

    $links.on('click', function (e) {
        e.preventDefault();

        var url = $(this).attr('href');

        if (!url) {
            console.error('Missing href');
            return;
        }

        var parsedUrl;
        try {
            parsedUrl = new URL(url, window.location.origin);
        } catch (err) {
            console.error('Invalid URL:', url);
            return;
        }

        var TRUSTED_DOMAINS = allowedDomains;

        function isAllowedHost(hostname, domains) {
            return domains.some(function (domain) {
                return hostname === domain ||
                    hostname.endsWith('.' + domain);
            });
        }

        if (
            parsedUrl.protocol === 'https:' &&
            isAllowedHost(parsedUrl.hostname, TRUSTED_DOMAINS)
        ) {
            window.location.assign(
                parsedUrl.origin + parsedUrl.pathname + parsedUrl.search
            );
        }

    });

}
